import axios, { AxiosError } from "axios"
import { ACCOUNT_TYPE_PATH, LIST_PATH } from "../../constants/paths"
import {
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials,
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
} from "interceptors"
const instance = axios.create({
  baseURL: process.env.REACT_APP_CONFIGURATION_API_SERVICE_DOMAIN,
})
instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getAccountTypessService = async () => {
  try {
    const result = await instance.get(ACCOUNT_TYPE_PATH + LIST_PATH)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const createAccountTypeService = async (accountType: any) => {
  try {
    const result = await instance.post(ACCOUNT_TYPE_PATH, accountType)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const deleteAccountTypeService = async (id: any) => {
  try {
    const result = await instance.delete(ACCOUNT_TYPE_PATH + `/${id}`)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const editAccountTypeService = async (id: number, accountType: any) => {
  try {
    const result = await instance.put(ACCOUNT_TYPE_PATH + `/${id}`, accountType)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
